export enum EntityEventMessengerEnum {
    ORGANIZATION_UPSERT = 'organization-upsert',
    ORGANIZATION_USER_UPSERT = 'organization-user-upsert',
    ORGANIZATION_USER_DELETE = 'organization-user-delete',
    ORGANIZATION_DELETE = 'organization-delete',
    USER_ROLE_UPSERT = 'user-role-upsert',
    NOTIFICATION_CREATE = 'notification-create',
    BACKGROUND_TASK_UPDATE = 'background-task-update',
    AUDIT_LOG_CREATE = 'audit-log-create',
    AUDIT_LOG_CREATE_MANUAL = 'audit-log-create-manual',
    FILE_UPSERT = 'file-upsert',
    FILE_DELETE = 'file-delete',
    VISIT_HISTORY = 'visit-history',

    // ACL
    GROUP_UPSERT = 'group-upsert',
    GROUP_DELETE = 'group-delete',
    GROUP_USER_UPSERT = 'group-user-upsert',
    GROUP_USERS_UPSERT = 'group-users-upsert',
    GROUP_USER_DELETE = 'group-user-delete',
    GROUP_PARENT_UPSERT = 'group-parent-upsert',
    GROUP_PARENT_DELETE = 'group-parent-delete',
    RULE_UPSERT = 'rule-upsert',
    RULE_DELETE = 'rule-delete',
    USER_UPSERT = 'user-upsert',
    USER_DELETE = 'user-delete',

    // MedicalServices
    FOLDER_UPSERT = 'folder-upsert',
    FOLDER_DELETE = 'folder-delete',
    SERVICE_PERSON_UPSERT = 'service-person-upsert',
    SERVICE_PERSON_DELETE = 'service-person-delete',
    SERVICE_PERSON_CONTACT_UPSERT = 'service-person-contact-upsert',
    SERVICE_PERSON_CONTACT_DELETE = 'service-person-contact-delete',
    EMPLOYMENT_UPSERT = 'employment-upsert',
    EMPLOYMENT_DELETE = 'employment-delete',
    EDUCATION_UPSERT = 'education-upsert',
    EDUCATION_DELETE = 'education-delete',
    EMPLOYMENT_TYPE_EDUCATION_UPSERT = 'employment-type-education-upsert',
    EMPLOYMENT_TYPE_EDUCATION_DELETE = 'employment-type-education-delete',
}

export const ignoredEventsForFE = [
    EntityEventMessengerEnum.NOTIFICATION_CREATE,
    EntityEventMessengerEnum.BACKGROUND_TASK_UPDATE,
    EntityEventMessengerEnum.AUDIT_LOG_CREATE,
    EntityEventMessengerEnum.AUDIT_LOG_CREATE_MANUAL,
];
